const DeviceReplacement = {
  DeviceReplacement: {
    toDoText: 'Controleer of de volgende stappen zijn uitgevoerd voordat u de vervanging start',
    toDoListItems: [
      'Ontkoppel het apparaat dat vervangen moet worden',
      'Sluit het vervangende apparaat aan',
      'Configureer het vervangende apparaat'
    ],
    install_replacement: {
      submitFirstStep: 'Details ophalen',
      hems_device_api_fault:
        'Als u een actieve belasting van derden probeert te vervangen, maar deze niet kunt zien in de vervolgkeuzelijst, laadt de pagina dan opnieuw.',
      labelOldDevice: 'Gegevens oude apparaat',
      labelNewDevice: 'Gegevens nieuwe apparaat',
      submitSecondStep: 'Vervanging bevestigen',
      warningText: `Als de apparaatgegevens onjuist zijn of voor een ander probleem, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >klik dan hier</a> om terug te gaan`,
      DeviceTypes: {
        EVSE: 'IQ ER EVSE',
        ENERGY_METER: 'Energiemeter',
        SG_READY_GATEWAY: 'SG ready relais',
        MICROINVERTER: 'Micro-omvormer',
        AC_BATTERY: 'AC batterij',
        selectDeviceType: 'selecteer apparaattype'
      }
    },
    replace_gateway: {
      submitFirstStep: 'IQ Energy Router vervangen',
      hems_device_api_fault:
        'Als u een actieve IQ Energy Router probeert te vervangen, maar deze niet kunt zien in de vervolgkeuzelijst, laadt de pagina dan opnieuw.',
      submitSecondStep: 'IQ Energy Router vervangen',
      labelOldDevice: 'Oude IQ ER Details',
      labelNewDevice: 'Nieuwe IQ ER Details',
      warningText: `Als de apparaatgegevens onjuist zijn of voor een ander probleem, <a style="color:#F37321;"  href="javascript: window.parent.location.reload();" >klik dan hier</a> om terug te gaan`,
      DeviceTypes: {
        IQ_ENERGY_ROUTER: 'IQ Energy Router',
        IQ_GATEWAY: 'IQ Gateway',
        selectDeviceType: 'Selecteer type gateway'
      }
    },
    alert: {
      footerMessage: 'Neem contact op met de klantenondersteuning van Enphase als het probleem zich blijft voordoen.',
      requestTimedOut: {
        mainMessage: 'Aanvraag is verlopen',
        subMessage: 'Probeer het later opnieuw'
      },
      multipleDeviceFound: {
        mainMessage: 'Vervanging niet ondersteund',
        subMessageIqErEvse:
          'Er zijn meer dan 1 IQ ER EVSE gedetecteerd op de site. Vervanging kan niet worden ondersteund voor dit type siteconfiguratie',
        subMessageEnergyMeter:
          'Er zijn meer dan 1 energiemeters gedetecteerd op de site. Vervanging kan niet worden ondersteund voor dit type siteconfiguratie',
        subMessageSgReadyRelay:
          'Er zijn meer dan 1 SG Ready Relais gedetecteerd op de site. Vervanging kan niet worden ondersteund voor dit type siteconfiguratie'
      },
      iqErOffline: {
        mainMessage: 'IQ ER rapporteert niet',
        subMessage: 'Controleer of de IQ Energy Router van stroom wordt voorzien en verbonden is met het internet.'
      },
      deviceNotOffline: {
        mainMessage: 'Oud apparaat verbonden',
        subMessage:
          'Verbinding met oud apparaat gedetecteerd. Koppel het oude apparaat los en start de vervanging opnieuw'
      },
      deviceReplacementInProgress: {
        mainMessage: 'Apparaat wordt al vervangen voor dit apparaattype'
      },
      deviceNotFound: {
        mainMessage: 'Nieuw apparaat niet gedetecteerd',
        subMessage:
          'Details nieuw apparaat niet gevonden. Controleer of het nieuwe apparaat is verbonden met internet en is geconfigureerd.'
      },
      invalidRmaStatusId: {
        mainMessage: 'Vervanging mislukt ',
        subMessage: 'Vervanging mislukt vanwege onbekende vervangingsstatus'
      },
      activationDuplicateSite: {
        mainMessage: 'Vervanging mislukt',
        subMessage: 'Vervanging mislukt omdat de nieuwe IQ Energy Router al actief is'
      },
      authPending: {
        mainMessage: 'Vervanging mislukt',
        subMessage: 'Vervanging mislukt omdat de bestaande IQ Energy Router nog niet is geautoriseerd'
      },
      invalidIqEnergyRouter: {
        mainMessage: 'Vervanging mislukt',
        subMessage: 'Vervanging mislukt omdat het ingevoerde serienummer van de IQ Energy Router ongeldig is'
      },
      hemsDevicesNotDiscovered: {
        mainMessage: 'Vervanging mislukt',
        subMessage: 'Vervanging mislukt omdat de eerder ontdekte HEMS 3rd party apparaten niet worden gevonden'
      },
      iqGatewayNotDiscovered: {
        mainMessage: 'Vervanging mislukt',
        subMessage: 'Sostituzione fallita perché il Gateway IQ non è ancora stato rilevato dal IQ Energy Router'
      },
      authInitFailed: {
        mainMessage: 'Vervanging mislukt',
        subMessage: 'Vervanging mislukt omdat autorisatie van het apparaat niet is gestart'
      },
      invalidDeviceType: {
        mainMessage: 'Apparaattype niet geldig voor vervanging',
        subMessage: 'Controleer of het juiste apparaattype is geselecteerd voordat u de aanvraag indient.'
      },
      invalidSite: {
        mainMessage: 'Niet ondersteund type site',
        subMessage: 'De siteconfiguratie ondersteunt deze vervanging niet'
      },
      invalidDevice: {
        mainMessage: 'De oude apparaat-ID lijkt ongeldig',
        subMessage: 'Vervanging wordt niet ondersteund voor dit'
      },
      invalidDeviceUid: {
        mainMessage: "Oude en nieuwe apparaat-ID's zijn hetzelfde",
        subMessage: 'Vervanging wordt niet ondersteund voor dit'
      },
      deviceReplacementCompleted: {
        mainMessage: 'Vervanging voltooid',
        subMessage:
          'Als er nog een functionele validatie voor het nieuwe apparaat moet worden uitgevoerd, voltooi deze dan met behulp van de Enphase Installer Application (ITK).'
      },
      itkSuccessMessage: {
        iqErEvse: 'EV Charger is succesvol vervangen',
        energyMeter: 'Energy meter is succesvol vervangen',
        sgReadyRelay: 'SG Ready Relay is succesvol vervangen',
        iqEnergyRouter: 'IQ Energy Router is succesvol vervangen'
      },
      fetchingDeviceDetailsLoader: { subMessage: 'Apparaatgegevens ophalen' },
      initiatingReplacementLoader: { subMessage: 'Vervanging in gang zetten' },
      replacementInprogressLoader: { subMessage: 'Vervanging bezig' }
    }
  }
};

export default DeviceReplacement;
